<div class="row justify-content-between">
     <div class="col-12 col-sm-6 searchEdit mb-3">
       <label for="searchEdit" class="sr-only">Records search</label>
       <input 
         [(ngModel)]="searchCriteria.searchString"
         type="text" 
         id="searchEdit"
         class="form-control form-control-search" 
         [placeholder]="'DashboardSearchInput' | translator: 'customer'" 
         [title]="'DashboardSearchInput' | translator: 'customer'" 
         (keyup)="emit(keyword.value);" #keyword
       />
     </div>
</div>